// 1. import `extendTheme` function
import { extendTheme } from "@chakra-ui/react";

// 2. Add your color mode config
const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const colors = {
  red: {
    50: "#ff8585",
    100: "#ed6666",
    200: "#e65353",
    300: "#cf3a3a",
    400: "#c93030",
    500: "#bf2828",
    600: "#E30613",
    700: "#a60510",
    800: "#78040c",
    900: "#590208",
  },
};

export default extendTheme({ config, colors });
